<script setup lang="ts">
import BaseTag from '@/components/library/ui/BaseTag.vue';
import BaseViews from '@/components/library/counter/BaseViews.vue';
import BaseAssetType from '@/components/library/ui/BaseAssetType.vue';
import BaseTitle from '@/components/library/typography/BaseTitle.vue';
import BaseDate from '@/components/library/counter/BaseDate.vue';
import BaseImage from '@/components/library/ui/BaseImage.vue';
import { paths } from '@/settings/settings';
import { getFormattedDuration } from '@/utils/helpers';

// const hoursMinutesString = useDateFormat();

interface Props {
  name: string;
  id: string;
  type: string;
  channelId: string;
  thumbnail: object;
  audit: {
    createdAtUtc: string;
  };
  usage: {
    downloads: string;
    views: number;
  };
  file: {
    duration: string;
  };
}

const props = defineProps<Props>();
</script>

<template>
  <li class="item">
    <router-link
      class="item__link"
      :class="{ 'item__link--active': $route.params.mediaId === id }"
      :to="paths.CHANNELS_ROUTE + channelId + paths.MEDIA_ROUTE + id"
    >
      <base-image
        class="item__thumbnail-wrapper"
        :thumbnail="thumbnail"
        alt=""
      />
      <base-tag
        v-if="file.duration"
        class="item__thumbnail-duration"
        color="white"
        size="small"
      >
        {{ getFormattedDuration(file.duration) }}
      </base-tag>
      <div class="grow">
        <base-title :hide="false" class="mb-1 break-all" tag="span">{{
          name
        }}</base-title>
        <div>
          <div class="flex justify-between items-center">
            <div class="flex gap-2 items-center">
              <base-asset-type :type="type" :file="file" />
              <base-views :count="usage.views" label="views" />
            </div>
            <base-date :date="audit.createdAtUtc" />
          </div>
        </div>
      </div>
    </router-link>
  </li>
</template>

<style scoped lang="postcss">
.item {
  &__link {
    @apply flex px-4 py-2 relative hover:bg-neutral-300 cursor-pointer box-border;

    &--active {
      @apply bg-neutral-300;
    }
  }

  &__thumbnail-wrapper {
    @apply basis-[10rem] shrink-0 h-[5.6rem] mr-2;
  }

  &__thumbnail-duration {
    @apply absolute z-10 left-7 top-3 shadow-sm;
  }

  :deep(.date),
  :deep(.wrapper) {
    @apply text-sm;
  }
}
</style>
